import React from 'react'

export default function HeroSections() {
    return (
        <div>
            <h1 className='font-bold text-center text-5xl md:text-7xl mt-40' >BudgetApp</h1>
        </div>
    )
}
